import { VFC } from "react";

import { Warning } from "src/components/warning";

const WorkspaceNotFoundPage: VFC = () => {
  return <Warning fullScreen subtitle="Please check the url" title="Workspace not found" />;
};

export default WorkspaceNotFoundPage;
